module.exports = __webpack_public_path__ + "assets/img/tips.f2812404.png";